import CollectionHideModalComponent from "./CollectionHideModalComponent";

export default CollectionHideModalComponent;